// components/ServicioCocinaNacionalidad.js
import React, { useState, useEffect } from 'react';
import {
  Table,Dropdown ,
  Button,
  Input,
  Select,
  Space,
  Typography,
  message,
  Tag,
  Row,
  Col,
  Statistic,
  Card,
  DatePicker,
  Tabs,
  Badge,
  Tooltip
} from 'antd';
import {
  SearchOutlined,
  ReloadOutlined,
  FilterOutlined,
  ExportOutlined,
  CoffeeOutlined,
  ShoppingOutlined,
  AppstoreOutlined,
  TeamOutlined,
  GlobalOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  BarChartOutlined
} from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';
import { BASE_URL } from '../utils/constants';

import { usePDFExport } from '../hooks/usePDFExport';
import PdfExportTable from './PdfExportTable';

const { Title, Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const ServicioCocinaNacionalidad = ({ visible, onClose, onSuccess, fechasBase }) => {
  // Estados principales
  const [datos, setDatos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [nacionalidades, setNacionalidades] = useState([]);
  const [fechas, setFechas] = useState({
    desde: fechasBase?.desde || dayjs().format('DD/MM/YYYY'),
    hasta: fechasBase?.hasta || dayjs().add(7, 'day').format('DD/MM/YYYY')
  });
  
  // Estados para filtros
  const [filtros, setFiltros] = useState({
    searchText: '',
    nacionalidadFilter: ''
  });
  
  // Estados para paginación
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`,
    pageSizeOptions: ['10', '20', '50', '100']
  });
  
  // Estados para ordenación
  const [sortedInfo, setSortedInfo] = useState({});
  
  // Totales
  const [totales, setTotales] = useState({
    Desayuno: 0,
    Almuerzo: 0,
    Cena: 0,
    TodoIncluido: 0,
    PicnicD: 0,
    PicnicA: 0,
    PicnicC: 0,
    TotalServicios: 0
  });

const { exportServicioCocinaNacionalidad  } = usePDFExport();
const [exporting, setExporting] = useState(false);

const hotelName = localStorage.getItem('hotelName') || 'Hotel';

  // Columnas de la tabla
  const columns = [    
{
        title: 'Fecha',
        dataIndex: 'Fecha',
        key: 'Fecha',
        onHeaderCell: () => ({ style: { fontSize: '12px' } }),    
        width: 90,
        sorter: (a, b) => new Date(a.Fecha) - new Date(b.Fecha),
        sortOrder: sortedInfo.columnKey === 'Fecha' && sortedInfo.order,
        render: (fecha) => {
          if (!fecha) return '-';
          const date = new Date(fecha);
          return (
            <div>
              <div style={{ fontWeight: 'bold' }}>
                {date.toLocaleDateString('es-ES', { weekday: 'short' })}
              </div>
              <div style={{ fontSize: '12px' }}>
                {date.toLocaleDateString('es-ES')}
              </div>
            </div>
          );
        },
        fixed: 'left',
      },    
    {
      title: 'Nacionalidad',
      dataIndex: 'Nacionalidad',
      key: 'Nacionalidad',
      width: 150,
      sorter: true,
      sortOrder: sortedInfo.columnKey === 'Nacionalidad' && sortedInfo.order,
      fixed: 'left',
      render: (nacionalidad) => (
        <Tag color="geekblue" style={{ fontWeight: 'bold' }}>
          <GlobalOutlined /> {nacionalidad}
        </Tag>
      ),
    },
      
      {
        title: 'Desayuno',
        dataIndex: 'Desayuno',
        key: 'Desayuno',
        onHeaderCell: () => ({ style: { fontSize: '12px' } }),    
        width: 90,
        sorter: (a, b) => a.Desayuno - b.Desayuno,
        sortOrder: sortedInfo.columnKey === 'Desayuno' && sortedInfo.order,
        render: (valor) => (
          <Tag color="orange" style={{ fontWeight: 'bold', minWidth: '50px', textAlign: 'center' }}>
            {valor}
          </Tag>
        ),
      },
      {
        title: 'Picnic D',
        dataIndex: 'PicnicD',
        key: 'PicnicD',
        onHeaderCell: () => ({ style: { fontSize: '12px' } }),    
        width: 85,
        sorter: (a, b) => a.PicnicD - b.PicnicD,
        sortOrder: sortedInfo.columnKey === 'PicnicD' && sortedInfo.order,
        render: (valor) => (
          <Badge 
            count={valor} 
            style={{ backgroundColor: '#fa8c16' }}
            showZero
          />
        ),
      },
      {
        title: 'Total D',
        dataIndex: 'TotalD',
        key: 'TotalD',
        onHeaderCell: () => ({ style: { fontSize: '12px' } }),    
        width: 85,
        sorter: (a, b) => a.TotalD - b.TotalD,
        sortOrder: sortedInfo.columnKey === 'TotalD' && sortedInfo.order,
        render: (valor) => (
          <div style={{ fontWeight: 'bold', color: '#d46b08', textAlign: 'center' }}>
            {valor}
          </div>
        ),
      },
      {
        title: 'Almuerzo',
        dataIndex: 'Almuerzo',
        key: 'Almuerzo',
        onHeaderCell: () => ({ style: { fontSize: '12px' } }),    
        width: 90,
        sorter: (a, b) => a.Almuerzo - b.Almuerzo,
        sortOrder: sortedInfo.columnKey === 'Almuerzo' && sortedInfo.order,
        render: (valor) => (
          <Tag color="green" style={{ fontWeight: 'bold', minWidth: '50px', textAlign: 'center' }}>
            {valor}
          </Tag>
        ),
      },
      {
        title: 'Picnic A',
        dataIndex: 'PicnicA',
        key: 'PicnicA',
        onHeaderCell: () => ({ style: { fontSize: '12px' } }),    
        width: 85,
        sorter: (a, b) => a.PicnicA - b.PicnicA,
        sortOrder: sortedInfo.columnKey === 'PicnicA' && sortedInfo.order,
        render: (valor) => (
          <Badge 
            count={valor} 
            style={{ backgroundColor: '#73d13d' }}
            showZero
          />
        ),
      },
      {
        title: 'Total A',
        dataIndex: 'TotalA',
        key: 'TotalA',
        onHeaderCell: () => ({ style: { fontSize: '12px' } }),    
        width: 85,
        sorter: (a, b) => a.TotalA - b.TotalA,
        sortOrder: sortedInfo.columnKey === 'TotalA' && sortedInfo.order,
        render: (valor) => (
          <div style={{ fontWeight: 'bold', color: '#389e0d', textAlign: 'center' }}>
            {valor}
          </div>
        ),
      },
      {
        title: 'Cena',
        dataIndex: 'Cena',
        key: 'Cena',
        onHeaderCell: () => ({ style: { fontSize: '12px' } }),    
        width: 90,
        sorter: (a, b) => a.Cena - b.Cena,
        sortOrder: sortedInfo.columnKey === 'Cena' && sortedInfo.order,
        render: (valor) => (
          <Tag color="blue" style={{ fontWeight: 'bold', minWidth: '50px', textAlign: 'center' }}>
            {valor}
          </Tag>
        ),
      },
      {
        title: 'Picnic C',
        dataIndex: 'PicnicC',
        key: 'PicnicC',
        onHeaderCell: () => ({ style: { fontSize: '12px' } }),    
        width: 85,
        sorter: (a, b) => a.PicnicC - b.PicnicC,
        sortOrder: sortedInfo.columnKey === 'PicnicC' && sortedInfo.order,
        render: (valor) => (
          <Badge 
            count={valor} 
            style={{ backgroundColor: '#597ef7' }}
            showZero
          />
        ),
      },
      {
        title: 'Total C',
        dataIndex: 'TotalC',
        key: 'TotalC',
        onHeaderCell: () => ({ style: { fontSize: '12px' } }),    
        width: 85,
        sorter: (a, b) => a.TotalC - b.TotalC,
        sortOrder: sortedInfo.columnKey === 'TotalC' && sortedInfo.order,
        render: (valor) => (
          <div style={{ fontWeight: 'bold', color: '#096dd9', textAlign: 'center' }}>
            {valor}
          </div>
        ),
      },
      {
        title: 'Todo Incluido',
        dataIndex: 'TodoIncluido',
        key: 'TodoIncluido',
        onHeaderCell: () => ({ style: { fontSize: '12px' } }),    
        width: 110,
        sorter: (a, b) => a.TodoIncluido - b.TodoIncluido,
        sortOrder: sortedInfo.columnKey === 'TodoIncluido' && sortedInfo.order,
        render: (valor) => {
          // Mostrar el valor exacto, no 99+
          return (
            <div style={{ 
              fontWeight: 'bold', 
              color: '#722ed1',
              textAlign: 'center',
              padding: '4px 8px',
              backgroundColor: '#f9f0ff',
              borderRadius: '4px',
              border: '1px solid #d3adf7'
            }}>
              {valor}
            </div>
          );
        },
      },
      {
        title: 'Total Servicios',
        key: 'TotalServicios',
        onHeaderCell: () => ({ style: { fontSize: '12px' } }),    
        width: 120,
        render: (_, record) => {
          const total = record.TotalD + record.TotalA + record.TotalC;
          return (
            <div style={{ 
              fontWeight: 'bold', 
              textAlign: 'center',
              padding: '4px',
              backgroundColor: total > 0 ? '#f6ffed' : '#fff',
              border: '1px solid #b7eb8f',
              borderRadius: '4px'
            }}>
              {total}
            </div>
          );
        },
      },
      {
        title: 'Observaciones',
        dataIndex: 'Observaciones',
        key: 'Observaciones',
        onHeaderCell: () => ({ style: { fontSize: '12px' } }),    
        width: 180,
        render: (obs) => (
          <div style={{ maxWidth: 180, fontSize: '12px' }}>
            {obs || '-'}
          </div>
        ),
      }
    ];

  // Cargar datos
  useEffect(() => {
    if (visible) {
      fetchDatos();
    }
  }, [visible, fechas]);

  const fetchDatos = async (params = {}) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      
      const queryParams = {
        fechaDesde: fechas.desde,
        fechaHasta: fechas.hasta,
        nacionalidad: filtros.nacionalidadFilter || undefined,
        search: filtros.searchText || undefined,
        sortField: params.sortField || sortedInfo.field || 'Fecha',
        sortOrder: params.sortOrder || (sortedInfo.order === 'descend' ? 'DESC' : 'ASC'),
        page: 1,
        pageSize: 10000  // Número grande para traer todos
      };
      
      const response = await axios.get(`${BASE_URL}/api/serviciococina/nacionalidad`, {
        headers: { Authorization: `Bearer ${token}` },
        params: queryParams
      });
      
      if (response.data.success) {
        setDatos(response.data.data || []);
        setTotales(response.data.totales || totales);
        setNacionalidades(response.data.nacionalidades || []);
      }
    } catch (error) {
      console.error('❌ Error cargando datos por nacionalidad:', error);
      message.error('Error al cargar los datos');
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
    
    const params = {
      sortField: sorter.field,
      sortOrder: sorter.order === 'ascend' ? 'ASC' : 'DESC'
    };
    
    fetchDatos(params);
  };

  const handleFiltrar = () => {
    fetchDatos();
  };

  const handleResetFiltros = () => {
    setFiltros({
      searchText: '',
      nacionalidadFilter: ''
    });
    setSortedInfo({});
    fetchDatos();
  };

  const handleFechasChange = (dates, dateStrings) => {
    if (dates && dates[0] && dates[1]) {
      setFechas({
        desde: dateStrings[0],
        hasta: dateStrings[1]
      });
    }
  };

  const handleExportar = async (formato = 'excel') => {
    try {
      if (formato === 'pdf') {
        if (!datos.length) {
          message.warning('No hay datos para exportar');
          return;
        }
        
        setExporting(true);
        message.loading('Generando reporte PDF...', 0);
        
        await exportServicioCocinaNacionalidad(datos, totales, {
          fechaDesde: fechas.desde,
          fechaHasta: fechas.hasta,
          nacionalidad: filtros.nacionalidadFilter || null,
          hotel: hotelName
        });
        
        message.destroy();
        message.success('Reporte PDF generado correctamente');
        setExporting(false);
        return;
      }
      
      message.loading('Exportando datos...', 0);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/api/serviciococina/nacionalidad/exportar`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { fechaDesde: fechas.desde, fechaHasta: fechas.hasta, formato }
      });
      
      if (response.data.success) {
        message.destroy();
        message.success(`Exportación (${formato.toUpperCase()}) lista para ${response.data.data.length} días`);
        const dataStr = JSON.stringify(response.data.data, null, 2);
        const dataUri = `data:application/json;charset=utf-8,${encodeURIComponent(dataStr)}`;
        const linkElement = document.createElement('a');
        linkElement.setAttribute('href', dataUri);
        linkElement.setAttribute('download', `servicio_cocina_${fechas.desde}_${fechas.hasta}.json`);
        linkElement.click();
      }
    } catch (error) {
      message.destroy();
      message.error('Error al exportar');
      setExporting(false);
    }
  };

  if (!visible) return null;

  return (
    <div style={{ padding: '20px', background: 'white' }}>
      {/* Título para PDF */}
      {/* <div style={{ textAlign: 'center', marginBottom: 20 }}>
        <h1>Servicio de Cocina por Nacionalidad</h1>
        <p>Período: {fechas.desde} al {fechas.hasta}</p>
        {filtros.nacionalidadFilter && <p>Nacionalidad: {filtros.nacionalidadFilter}</p>}
        <p>Generado: {new Date().toLocaleString()}</p>
      </div> */}
      {/* Filtros */}
      <Card size="small" title="Filtros" extra={<FilterOutlined />} style={{ marginBottom: 16 }}>
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={8} lg={6}>
            <div>
              <Text strong style={{ display: 'block', marginBottom: 4 }}>Fechas (DD/MM/YYYY):</Text>
              <RangePicker
                style={{ width: '100%' }}
                format="DD/MM/YYYY"
                value={[dayjs(fechas.desde, 'DD/MM/YYYY'), dayjs(fechas.hasta, 'DD/MM/YYYY')]}
                onChange={handleFechasChange}
              />
            </div>
          </Col>
          
          <Col xs={24} sm={24} md={8} lg={6}>
            <div>
              <Text strong style={{ display: 'block', marginBottom: 4 }}>Nacionalidad:</Text>
              <Select
                style={{ width: '100%' }}
                placeholder="Todas las nacionalidades"
                value={filtros.nacionalidadFilter || undefined}
                onChange={(value) => setFiltros({ ...filtros, nacionalidadFilter: value })}
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {nacionalidades.map(nac => (
                  <Option key={nac} value={nac}>{nac}</Option>
                ))}
              </Select>
            </div>
          </Col>
          
          <Col xs={24} sm={24} md={8} lg={6}>
            <div>
              <Text strong style={{ display: 'block', marginBottom: 4 }}>Búsqueda:</Text>
              <Input
                placeholder="Buscar por nacionalidad..."
                value={filtros.searchText}
                onChange={(e) => setFiltros({ ...filtros, searchText: e.target.value })}
                prefix={<SearchOutlined />}
                allowClear
                onPressEnter={handleFiltrar}
              />
            </div>
          </Col>
          
          <Col xs={24} sm={24} md={8} lg={6}>
            <Space>
              <Button
                type="primary"
                icon={<FilterOutlined />}
                onClick={handleFiltrar}
              >
                Aplicar Filtros
              </Button>
              <Button
                icon={<ReloadOutlined />}
                onClick={handleResetFiltros}
              >
                Restablecer
              </Button>
              <Tooltip title="Exportar datos">
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: 'excel',
                        label: 'Exportar a Excel',
                        icon: <FileExcelOutlined />,
                        onClick: () => handleExportar('excel')
                      },
                      {
                        key: 'pdf',
                        label: 'Exportar a PDF',
                        icon: <FilePdfOutlined />,
                        onClick: () => handleExportar('pdf')
                      }
                    ]
                  }}
                >
                  <Button icon={<ExportOutlined />}>
                    Exportar
                  </Button>
                </Dropdown>
              </Tooltip>
            </Space>
          </Col>
        </Row>
      </Card>
     
      {/* Estadísticas
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col xs={24} sm={12} md={6} lg={4}>
          <Statistic 
            title="Total Desayunos" 
            value={totales.Desayuno}
            prefix={<CoffeeOutlined />}
            valueStyle={{ color: '#d46b08' }}
          />
        </Col>
        <Col xs={24} sm={12} md={6} lg={4}>
          <Statistic 
            title="Total Almuerzos" 
            value={totales.Almuerzo}
            prefix={<ShoppingOutlined />}
            valueStyle={{ color: '#389e0d' }}
          />
        </Col>
        <Col xs={24} sm={12} md={6} lg={4}>
          <Statistic 
            title="Total Cenas" 
            value={totales.Cena}
            prefix={<AppstoreOutlined />}
            valueStyle={{ color: '#096dd9' }}
          />
        </Col>
        <Col xs={24} sm={12} md={6} lg={4}>
          <Statistic 
            title="Todo Incluido" 
            value={totales.TodoIncluido}
            prefix={<TeamOutlined />}
            valueStyle={{ color: '#722ed1' }}
          />
        </Col>
        <Col xs={24} sm={12} md={6} lg={4}>
          <Statistic 
            title="Total Picnics" 
            value={totales.PicnicD + totales.PicnicA + totales.PicnicC}
            prefix={<GlobalOutlined />}
            valueStyle={{ color: '#13c2c2' }}
          />
        </Col>
        <Col xs={24} sm={12} md={6} lg={4}>
          <Statistic 
            title="Total Servicios" 
            value={totales.TotalServicios}
            prefix={<BarChartOutlined />}
            valueStyle={{ color: '#1890ff' }}
          />
        </Col>
      </Row> */}

      {/* Tabla principal */}
      <Table
        columns={columns}
        dataSource={datos}
        rowKey={(record) => `${record.Fecha}-${record.Nacionalidad}`}
        loading={loading}
        onChange={handleTableChange}
        pagination={false}
        scroll={{ x: 1000, y: 500 }}
        style={{
          borderRadius: '8px',
          overflow: 'hidden'
        }}
        size="middle"
        locale={{
          emptyText: 'No se encontraron datos para el período seleccionado'
        }}
        summary={() => (
          <Table.Summary fixed>
            <Table.Summary.Row style={{ backgroundColor: '#fafafa' }}>
              <Table.Summary.Cell index={0}><Text strong>TOTALES</Text></Table.Summary.Cell>
              <Table.Summary.Cell index={0}><Text strong></Text></Table.Summary.Cell>              
              <Table.Summary.Cell index={1}><Text strong style={{ color: '#d46b08' }}>{totales.Desayuno}</Text></Table.Summary.Cell>
              <Table.Summary.Cell index={2}><Text strong style={{ color: '#d46b08' }}>{totales.TotalPicnicD}</Text></Table.Summary.Cell>                          
              <Table.Summary.Cell index={2}><Text strong style={{ color: '#d46b08' }}>{totales.TotalD}</Text></Table.Summary.Cell>
              <Table.Summary.Cell index={3}><Text strong style={{ color: '#389e0d' }}>{totales.Almuerzo}</Text></Table.Summary.Cell>
              <Table.Summary.Cell index={3}><Text strong style={{ color: '#389e0d' }}>{totales.TotalPicnicA}</Text></Table.Summary.Cell>                          
              <Table.Summary.Cell index={4}><Text strong style={{ color: '#389e0d' }}>{totales.TotalA}</Text></Table.Summary.Cell>
              <Table.Summary.Cell index={5}><Text strong style={{ color: '#096dd9' }}>{totales.Cena}</Text></Table.Summary.Cell>
              <Table.Summary.Cell index={3}><Text strong style={{ color: '#096dd9' }}>{totales.TotalPicnicC}</Text></Table.Summary.Cell>                                                    
              <Table.Summary.Cell index={6}><Text strong style={{ color: '#096dd9' }}>{totales.TotalC}</Text></Table.Summary.Cell>
              <Table.Summary.Cell index={7}><Text strong style={{ color: '#722ed1' }}>{totales.TodoIncluido}</Text></Table.Summary.Cell>
              <Table.Summary.Cell index={8} colSpan={2}>
                <Text type="secondary">Total servicios: {totales.TotalD + totales.TotalA + totales.TotalC}</Text>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
      />     
      {/* Componente oculto para PDF con TODOS los datos */}
      {/*<div style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}>
         <PdfExportTable
          ref={pdfTargetRef}
          type="nacionalidad"
          title="Servicio de Cocina por Nacionalidad"
          subtitle={`Período: ${fechas.desde} al ${fechas.hasta}${filtros.nacionalidadFilter ? ` | Nacionalidad: ${filtros.nacionalidadFilter}` : ''}`}
          columns={columns}
          data={datos}
          totales={totales}
        />
      </div> */}
    </div>    
  );
};

export default ServicioCocinaNacionalidad;